import React from 'react';
import { Typography, TypographyProps } from '@mui/material';

interface WalkthroughTitleProps extends Omit<TypographyProps, 'sx'> {
  children: React.ReactNode;
}

/**
 * WalkthroughTitle component - A standardized title for walkthrough guide modals
 * 
 * This component provides consistent styling for titles used in the WalkthroughGuide,
 * ensuring uniform appearance across all guide screens.
 * 
 * @param props - Component props
 * @returns WalkthroughTitle component
 */
const WalkthroughTitle: React.FC<WalkthroughTitleProps> = ({ children, ...rest }) => {
  return (
    <Typography 
      {...rest}
      sx={{ 
        fontSize: '20px', 
        color: theme => theme.palette.text.primary,
        fontFamily: '"Montserrat"',
        lineHeight: '20px',
        fontWeight: 600, 
        letterSpacing: '-0.4px'
      }}
    >
      {children}
    </Typography>
  );
};

export default WalkthroughTitle;